import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    ARBResponseForAdjustTime: {},
    ARBResponseForValidate: {},
    ARBResponseForStopViewComputeEstimates: {},
    ARBResponseForStopViewValidate: {},
    StopViewBreakTrip: {},
    ARBResponseForRouteSuggestionAdjustTime: {},
    ARBResponseForRouteSuggestionValidate: {},
    ARBResponseForRouteSuggestionNoViolation: {}
};

const ARBSlice = createSlice({
    name: "ARB",
    initialState,
    reducers: {
        SetARBResponsePersistData: (state, action) => {
            const { name, data } = action.payload;
            if (name === "ARBResponseForAdjustTime") {
                state.ARBResponseForAdjustTime = data;
            } 
            else if (name === "ARBResponseForValidate") {
                state.ARBResponseForValidate = data;
            } 
            else if (name === "ARBResponseForStopViewComputeEstimates") {
                state.ARBResponseForStopViewComputeEstimates = data;
            } 
            else if (name === "ARBResponseForStopViewValidate") {
                state.ARBResponseForStopViewValidate = data;
            }
            else if (name === "StopViewBreakTrip") {
                state.StopViewBreakTrip = data;
            }
            else if (name === "ARBResponseForRouteSuggestionValidate") {
                state.ARBResponseForRouteSuggestionValidate = data;
            }
            else if (name === "ARBResponseForRouteSuggestionAdjustTime") {
                state.ARBResponseForRouteSuggestionAdjustTime = data;
            }
            else if (name === "ARBResponseForRouteSuggestionNoViolation") {
                state.ARBResponseForRouteSuggestionNoViolation = data;
            }
        }
    }
});

export const { SetARBResponsePersistData } = ARBSlice.actions;
export default ARBSlice.reducer;
